import React, { useEffect, useState } from "react";

import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import { useTranslation } from "react-i18next";
const RoleInfo = (props) => {
  const {
    formik,
    next,
    bankGroupList,
    bankList,
    setBankId,
    setBranchId,
    branchNameList,
    handleError,
    handleCompletion,
  } = props;
  const {
    bankGroupId: bankGroupIdValue,
    bankId: bankIdValue,
    branchId: branchIdValue,
  } = formik.values;
  const {
    bankGroupId: bankGroupIdError,
    bankId: bankIdError,
    branchId: branchIdError,
  } = formik.errors;
  const { bankId: bankIdTouch, branchId: branchIdTouch } = formik.touched;
  const STEP_ID = 1;
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(() =>
    bankGroupIdValue &&
    bankIdValue &&
    branchIdValue &&
    !bankIdError &&
    !bankGroupIdError &&
    !branchIdError
      ? false
      : true
  );
  useEffect(() => {
    setDisabled(
      bankGroupIdValue &&
        bankIdValue &&
        branchIdValue &&
        !bankIdError &&
        !bankGroupIdError &&
        !branchIdError
        ? false
        : true
    );
  }, [
    bankGroupIdValue,
    bankIdValue,
    branchIdValue,
    bankIdError,
    bankGroupIdError,
    branchIdError,
  ]);
  useEffect(() => {
    if (!disabled) {
      handleError(STEP_ID, false);
      handleCompletion(STEP_ID, true);
    } else if (disabled) {
      handleError(STEP_ID, true);
      handleCompletion(STEP_ID, false);
    }
  }, [disabled]);

  return (
    <>
      <div className="inputField mt-2">
        <SearchableSelect
          placeholder="Select Bank Group"
          name="bankGroupId"
          handleChange={(key, value) => {
            formik.setFieldValue(key, value);
          }}
          options={bankGroupList}
          value={bankGroupIdValue}
          defaultValue={bankGroupIdValue}
          errors={bankGroupIdValue > 10 && bankGroupIdError}
          isDisabled={true}
        />
      </div>

      <div className="inputField mt-2">
        <SearchableSelect
          placeholder={t("select-bank")}
          name="bankId"
          handleChange={(key, value) => {
            formik.setFieldValue(key, value);
            setBankId(value);
          }}
          options={bankList.map((bank) => {
            return { value: bank.bankId, label: bank.bankName };
          })}
          value={bankIdValue}
          errors={bankIdTouch && bankIdError}
          isDisabled={true}
          defaultValue={bankIdValue}
        />
      </div>
      <div className="inputField mt-2 d-none">
        <SearchableSelect
          placeholder={t("select-branch")}
          name="branchId"
          handleChange={(key, value) => {
            formik.setFieldValue(key, value);
            setBranchId(value);
          }}
          options={branchNameList.map((branch) => {
            return { value: branch.branchId, label: branch.branchName };
          })}
          value={branchIdValue}
          errors={branchIdTouch && branchIdError}
          isDisabled={true}
          defaultValue={branchIdValue}
        />
      </div>

      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            ...(disabled && { filter: "  opacity(30%)" }),
          }}
          disabled={disabled}
          onClick={next}
        >
          {t("next")}
        </button>
      </div>
    </>
  );
};

export default RoleInfo;
